import { ModalEvent, DialogProps, ModalContent } from './types'

function showModal(component: ModalContent, dialogProps?: DialogProps) {
  dispatchEvent(
    new CustomEvent('modal-display', {
      detail: {
        component,
        dialogProps,
      } as ModalEvent,
    })
  )
}

function closeModal() {
  dispatchEvent(
    new CustomEvent('modal-display', {
      detail: null,
    })
  )
}

export { showModal, closeModal }
